import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Amplify from "aws-amplify";
import Gravatar from "vue-gravatar";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import awsconfig from "./aws-exports";
var VueCookie = require("vue-cookie");
import DefaultLayout from "./layouts/DefaultCardLayout";
import FullPageLayout from "./layouts/FullPageLayout";

import {
  applyPolyfills,
  defineCustomElements,
} from "@aws-amplify/ui-components/loader";

Amplify.configure(awsconfig);
applyPolyfills().then(() => {
  defineCustomElements(window);
});

Vue.config.productionTip = false;

// Amplify.configure({
//   Auth: {
//     // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
//     identityPoolId: "eu-west-2:b4698d9d-ee88-4be0-b0a6-eeed59cb5c38",

//     // REQUIRED - Amazon Cognito Region
//     region: "eu-west-2",

//     // OPTIONAL - Amazon Cognito User Pool ID
//     userPoolId: "eu-west-2_gszUhp2O7",

//     // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
//     userPoolWebClientId: "6qthcupd4a75efi1g2mkac2fcr",

//     aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS"
//   }
// });

// Amplify.configure({
//   Auth: {
//     // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
//     identityPoolId: "eu-west-2:68b130d6-f347-4dd3-88db-5b4114173480",

//     // REQUIRED - Amazon Cognito Region
//     region: "eu-west-2",

//     // OPTIONAL - Amazon Cognito User Pool ID
//     userPoolId: "eu-west-2_LPRMIEshM",

//     // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
//     userPoolWebClientId: "1bfiar4ks2hpl4dabb827f367f",

//     aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS"
//   }
// });

// Auth.configure({
//   identityPoolId: "eu-west-2:68b130d6-f347-4dd3-88db-5b4114173480",
//   region: "eu-west-2",
//   userPoolId: "eu-west-2_LPRMIEshM",
//   userPoolWebClientId: "1bfiar4ks2hpl4dabb827f367f"
// });

Vue.use(VueCookie);

Vue.use(require("vue-moment"));

Vue.component("v-gravatar", Gravatar);

Vue.config.productionTip = false;
Vue.component("DefaultLayout", DefaultLayout);
Vue.component("FullPageLayout", FullPageLayout);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

// Let's style this up
require("./assets/style.css");
